/**
 * Searches for html element with name '__RequestVerificationToken' and returns value of first element found.
 * @returns {String} - anti forgery token
 */
export function getAntiForgeryToken() {
    const element = document.getElementsByName('__RequestVerificationToken');
    if (!element || element.length === 0) return null;
    return element[0].value;
}